import { SortedMappingItem } from '@modeso/types__aumico-lib-annualreport-be';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { IAddSubtotalFormDialogResult } from './add-subtotal-form-dialog-result.interface';

export interface IAddSubtotalFormDialogData {
    groupOptions: INameId[];
    flisAndGroupsPositionOptions: INameId[];
    subTotalSaveData?: IAddSubtotalFormDialogResult;
    allItemsInSelectedScope: SortedMappingItem[];
}
